<template>
  <div class="introduce flex">
    <div
      class="introduce-left flex flex-column flex-between flex-middle flex-1"
    >
      <div>
        <h2>实验室介绍</h2>
        <p>Laboratory Introduction</p>
        <div class="text">
          {{ detail.laboratoryBrief }}
        </div>
      </div>
      <!-- <div class="introduce-left-more flex flex-center flex-column">
        <router-link :to="'/homeAboutUs'" class="flex">
          了解更多详情
          <img :src="$oss('home/more.svg')" alt="了解更多详情" class="ml20" />
        </router-link>
        <p>Understand The Product</p>
      </div> -->
    </div>
    <div class="introduce-right">
      <el-carousel
        height="350px"
        :indicator-position="'none'"
        v-if="banners.length"
      >
        <el-carousel-item
          v-for="(img, idx) in banners"
          :key="`${idx}_laboratoryBanner`"
        >
          <img :src="img" class="introduce-right-img" />
        </el-carousel-item>
      </el-carousel>
      <img v-img="null" class="introduce-right-img" v-else />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
    banners: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.introduce {
  padding-top: 50px;
  &-left {
    padding-right: 24px;
    h2 {
      color: #333;
      font-size: 32px;
    }
    .text {
      line-height: 24px;
      text-align: justify;
      padding: 30px 0;
    }
    p {
      color: #999;
      font-size: 14px;
    }
    &-more {
      padding: 0 20px;
      height: 110px;
      background: #216df2;
      font-size: 24px;
      a {
        text-decoration: none;
        color: #fff;
      }
      p {
        color: rgba(#fff, 0.8);
      }
      img {
        transition: all ease-in-out 0.3s;
      }
      &:hover img {
        transform: translateX(10px);
      }
    }
  }
  &-right {
    // padding-top: 40px;
    width: 590px;
    &-img {
      display: block;
      width: 100%;
      height: 370px;
      object-fit: contain;
    }
  }
}
.ml20 {
  margin-left: 20px;
}
</style>
